import Joi from 'joi';
import { DELIVERABLES_EXECUTION_STATUS_REJECTED_SELECT_OPTIONS } from 'components/Deliverable/constants';

const schema = {
  type: Joi.string().valid('count', 'content'),
  sort: Joi.string().default('propertyName-asc'),
  limit: Joi.number().default(24),
  skip: Joi.number().default(0),
  presetId: Joi.number().allow(null),
  // includePermissions: Joi.boolean().default(false),
  // groupBy: Joi.string().default('production'),
  id: Joi.array().items(Joi.number()).default([]),
  idExclude: Joi.array().items(Joi.number()).default([]),
  query: Joi.string().allow(null, '').default(''),
  ftcCompliant: Joi.string().valid('yes', 'no', 'all'),
  productionId: Joi.array().items(Joi.number()).default([]),
  productionType: Joi.array().items(Joi.string()).default([]),
  campaignId: Joi.array().items(Joi.number()).default([]),
  brandId: Joi.array().items(Joi.number()).default([]),
  propertyId: Joi.array().items(Joi.number()).default([]),
  programId: Joi.array().items(Joi.number()).default([]),
  likedByAI: Joi.boolean(),
  createdByAI: Joi.boolean(),
  hasPlacements: Joi.boolean(),
  likedById: Joi.array().items(Joi.number()).default([]),
  negotiatedById: Joi.array().items(Joi.number()).default([]),
  executedById: Joi.array().items(Joi.number()).default([]),
  coordinatorId: Joi.array().items(Joi.number()).default([]),
  executionStatusExclude: Joi.array()
    .items(
      Joi.object().keys({
        name: Joi.string(),
        phase: Joi.string(),
      }),
    )
    .default(DELIVERABLES_EXECUTION_STATUS_REJECTED_SELECT_OPTIONS),
  executionStatus: Joi.array()
    .items(
      Joi.object().keys({
        name: Joi.string(),
        phase: Joi.string(),
      }),
    )
    .default([]),
  airDate: Joi.object().keys({
    from: Joi.date().iso().allow(null, ''),
    to: Joi.date().iso().allow(null, ''),
    includeNoDates: Joi.boolean(),
  }),
  shootDate: Joi.object().keys({
    from: Joi.date().iso().allow(null, ''),
    to: Joi.date().iso().allow(null, ''),
    includeNoDates: Joi.boolean(),
  }),
  targetCogs: Joi.object()
    .keys({
      from: Joi.number().allow(null),
      to: Joi.number().allow(null),
    })
    .allow(null),
  payment: Joi.object().keys({
    status: Joi.string().valid(
      'paid',
      'unpaid',
      'pendingOpen',
      'cancelled',
      'unclaimedPaypal',
      'completedPaypal',
      'readyForPayment',
    ),
    type: Joi.string().valid('paypal', 'achWire', 'check'),
    dueDate: Joi.object().keys({
      from: Joi.date().iso().allow(null, ''),
      to: Joi.date().iso().allow(null, ''),
    }),
  }),
  network: Joi.array().items(Joi.number()).default([]),
  searchType: Joi.string()
    .valid('strict', 'loose', 'bulk', 'bulkById')
    .default('strict'),
  channels: Joi.array()
    .items(
      Joi.object({
        channel: Joi.string(),
        classes: Joi.array()
          .items(
            Joi.object({
              class: Joi.string(),
              genres: Joi.array()
                .items(
                  Joi.object({
                    genre: Joi.string(),
                    subgenres: Joi.array().items(Joi.string()).allow(null),
                  }),
                )
                .allow(null),
            }),
          )
          .allow(null),
      }),
    )
    .allow(null)
    .default([]),
};

export default schema;
